import styled from 'styled-components'

import { _M_Normal, _XL_Bold, Button, mainColors } from '@avantstay/backoffice-core'

import { Section } from '@new/__global/components/Section'

interface RootProps {
  bgColor?: string
}

export const Root = styled(Section)<RootProps>`
  color: ${mainColors.neutralLight};
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  background-color: ${({ bgColor }) => bgColor || mainColors.white};
`
export const Title = styled.h3`
  ${_XL_Bold};
  color: ${mainColors.black};
  margin-top: 30px;
  margin-bottom: 14px;
`

export const Description = styled.p`
  max-width: 453px;
  ${_M_Normal};
  text-align: center;
  line-height: 20px;
  color: ${mainColors.neutralExtraDark};
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 30px;

  > button {
    width: auto;
    flex: 0 0 auto;
  }
`

export const ActionButton = styled(Button.Primary)`
  margin-top: 30px;
  padding: 10px 30px;
  height: 40px;
  width: 150px;
`
